import { IOrganization, UserDataAndOrganization } from 'types/models/OrganizationModels';
import { useEffect, useMemo, useState } from 'react';

import { AppButton } from 'components/form';
import { Select } from '@trackman/web-shared-components';
import { UserType } from 'types/ProfileTypes';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const SelectOrganizationStep = observer(
  ({
    selectedUser,
    organization,
    onChangeUserType,
    onClickNext,
  }: {
    organization: IOrganization | null;
    selectedUser: UserDataAndOrganization | null;
    onChangeUserType: (userType: UserType) => void;
    onClickNext: () => void;
  }) => {
    if (!organization || !selectedUser) return <></>;
    const { t } = useTranslation();
    const { usersStore } = useStores();
    const [userType, setUserType] = useState<UserType>((selectedUser?.type as UserType.Admin | null) || UserType.Admin);

    const SELECT_OPTIONS = useMemo(
      () =>
        usersStore.userRoles.map((role) => ({
          value: UserType[role],
          label: t(role) as string,
        })),
      []
    );

    const onChangeUserTypeHandler = (e) => {
      const type = e.target.value as UserType;
      setUserType(type);
      onChangeUserType(type);
    };

    useEffect(() => {
      if (!selectedUser) {
        setUserType(UserType.Admin);
        return;
      }
      setUserType(selectedUser.type as UserType);
    }, [selectedUser]);

    return (
      <section>
        {selectedUser?.organization && (
          <p>
            {t('thisUserBelongsTo')}:
            <span className='ml-2 font-weight-bold'>
              {selectedUser.organization.name} {selectedUser.organization.shortName ? `(${selectedUser.organization.shortName})` : ''}
            </span>
          </p>
        )}
        <div className='card p-3'>
          <p className='font-18'>{t('thisUserWillBeAddedTo')}:</p>
          <p>
            {t('organization')}:
            <span className='ml-2 font-weight-bold'>
              {organization.name} {organization.shortName ? `(${organization.shortName})` : ''}
            </span>
          </p>
          <div>
            <Select
              label={t('type') as string}
              width={'300px'}
              notched={false}
              value={userType}
              onChange={onChangeUserTypeHandler}
              selectOptions={SELECT_OPTIONS}
            />
          </div>
          <AppButton
            className='position-absolute right-1rem bottom-1rem'
            variant='primary'
            disabled={!userType}
            onClick={onClickNext}
            data-test='user-dialog-type-step-next-button'
          >
            {t('next')}
          </AppButton>
        </div>
      </section>
    );
  }
);

export default SelectOrganizationStep;
